import styled, { AnyStyledComponent } from 'styled-components';
import COLORS from '../../style/universal.color';
import { MLBTheme } from '../../style/theme.types';

const {
  mlbGrey2,
  mlbGrey4
} = COLORS;

interface TableProps {
  tableFixed: boolean;
  dark: boolean;
  paddingConfig: TableCellPaddingConfig;
  hideDividers: boolean;
  tfootExists: boolean;
  hoverRowHighlight: boolean;
  highlightColor: string;
  theme: MLBTheme;
}

interface TableScrollerProps {
  divWidth: string;
  dark: boolean;
  hideDividers: boolean;
  leftPadding?: string;
  rightPadding?: string;
}

export interface TableCellPaddingConfig {
  bodyTdPadding: string;
  bodyThPadding: string;
  headThPadding: string;
}

interface TableContainerProps {
  containerWidth: string;
  containerMaxWidth: string;
}


export const StyledTable: AnyStyledComponent = styled.table`
  ${ (props: TableProps) => props.tableFixed ? 'table-layout: fixed;' : ''}
  font-family: ${({ theme = {}}: TableProps) => theme.fonts?.family?.primary};
  width: 100%;
  padding-bottom: 5px;
  border-collapse: collapse;
  overflow-x: hidden;

  thead {
    ${({dark, hideDividers}: TableProps) => !hideDividers ? `border-bottom: 1px solid ${ dark ? mlbGrey4 : mlbGrey2 };` : ''}
    margin-bottom: 20px;
    th {
      ${({hideDividers}: TableProps) => hideDividers ? `border-bottom: none;` : ''}
      padding: ${ ({paddingConfig}: TableProps) => paddingConfig.headThPadding};
    }
  }

  tbody {
    th {
      padding: ${ ({paddingConfig}: TableProps) => paddingConfig.bodyThPadding};
    }
    td {
      padding: ${ ({paddingConfig}: TableProps) => paddingConfig.bodyTdPadding};
    }

    ${({hoverRowHighlight, highlightColor}: TableProps) => hoverRowHighlight ? `
      tr {
        &:hover {
          background-color: ${highlightColor};
          border-radius: 4px;
          th {
            background-color: ${highlightColor};
          }
          td, th {
            border-radius: 0px;
            &:first-child {
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
            }
            &:last-child {
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
            }
          }
        }
      }
      
    ` : ''}
    

    ${({hideDividers, tfootExists}: TableProps) => !hideDividers ? `
        &:before {
          width: 100%;
          content: '';
          display: block;
          line-height: 10px;
          height: 5px;  
        }
        ${tfootExists ? `&:after {
            content: '';
            display: block;
            line-height: 10px;
            height: 5px;
          }` : ''
        }
    ` : '' }
  }

  tfoot {
    th {
      padding: ${ ({paddingConfig}: TableProps) => paddingConfig.bodyThPadding};
    }
    td {
      padding: ${ ({paddingConfig}: TableProps) => paddingConfig.bodyTdPadding};
    }
    ${({dark, hideDividers}: TableProps) => !hideDividers ? `border-top: 1px solid ${ dark ? mlbGrey4 : mlbGrey2 };` : ''}
  }
`;

export const TableScroller: AnyStyledComponent = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  width: ${(props: TableScrollerProps) => `calc(${props.divWidth} - ${props.leftPadding} - ${props.rightPadding})`};
  display: inline-block;
  margin-right: ${(props: TableScrollerProps) => props.rightPadding};
  margin-left: ${({ leftPadding }: TableScrollerProps) => (leftPadding)};
`;

export const TableContainer: AnyStyledComponent = styled.div`
  width: ${({ containerWidth }: TableContainerProps) => containerWidth };
  max-width: ${({ containerMaxWidth }: TableContainerProps) => containerMaxWidth };
  position: relative;
  display: inline-block;
  overflow: hidden;
`;
